module.exports = __webpack_public_path__ + "82bbba87b7d78dcc23f5bbf89b18c370.png";